// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","loader":"styles_loader__U8X4w","loaderInverseColor":"styles_loaderInverseColor__dxJgg","disabled":"styles_disabled__GZrd+"};